module.exports = __webpack_public_path__ + "img/jameson-2-text.a8916a4d.png";